import { getRegistrationPath } from '../redux/selectors/appData';
import { getIn } from 'icepick';

const SUPPORTED_CREDIT_CARDS = {
  VISA: 'Visa',
  MASTERCARD: 'MasterCard',
  AMERICAN_EXPRESS: 'AmericanExpress',
  DISCOVER: 'Discover',
  DINERS_CLUB: 'DinersClub',
  DINERS_CLUB_CARTEBLANCHE: 'DinersClub',
  DINERS_CLUB_ENROUTE: 'DinersClub',
  DINERS_CLUB_INTERNATIONAL: 'DinersClub',
  JCB: 'JCB',
  UNION_PAY: 'UnionPay'
};

/**
 * Returns cardType in Account Card Type format.
 * @param {string} cardType
 * @returns {string}
 */
export function transformCreditCardToAccountCardType(cardType) {
  if (!cardType) return;
  return SUPPORTED_CREDIT_CARDS[cardType];
}

/**
 * Returns cardType in Travel Card Type format
 * @param {Object} dateObj
 * @returns {string}
 */
export function transformCreditCardToTravelCardType(cardType) {
  if (!cardType) return;

  for (let i in SUPPORTED_CREDIT_CARDS) {
    if (SUPPORTED_CREDIT_CARDS[i] === cardType) {
      return i;
    }
  }
}

/**
 * Returns supported cards types
 * @param {Object} state
 * @returns {Array}
 */
export function getSupportedCardsForAccount(state) {
  const accountCreditCards = getIn(state, ['account', 'settings', 'offlineCreditCards']) || [];
  const supportedCardTypes = Object.values(SUPPORTED_CREDIT_CARDS);
  return accountCreditCards.reduce((accumulator, cardObj) => {
    const newAccumulator = [...accumulator];
    if (supportedCardTypes.includes(cardObj.paymentMethodId)) {
      newAccumulator.push(cardObj.paymentMethodId);
    }
    return newAccumulator;
  }, []);
}

/**
 * Returns travel credit card setting with applicable card types
 * @param {Object} state
 * @param {string} registrationPathId
 * @returns {Object}
 */
export function getApplicableCreditCardSettings(state, registrationPathId) {
  let travelCreditCardSettings = getIn(getRegistrationPath(state.appData, registrationPathId),
    ['travelSettings', 'travelCreditCardSettings']);
  if (!travelCreditCardSettings) return {};

  const accountCreditCards = getSupportedCardsForAccount(state);
  const acceptedCardTypes = accountCreditCards
    .filter((card) => travelCreditCardSettings.acceptedCardTypes.includes(card));
  return {
    ...travelCreditCardSettings,
    acceptedCardTypes
  };
}

/**
 * Returns if travel credit card widget should be displayed or not
 * @param {Object} state
 * @returns {boolean}
 */
export function isTravelCCWidgetVisible(state) {
  return (!getIn(state, ['account', 'settings', 'allowExtendedLogin'])
    && getSupportedCardsForAccount(state).length > 0);
}
